module.exports = __webpack_public_path__ + "static/media/raknroll-logo-marker.9063b14b.png";